<template>
  <div class="SmsEdit">

    <LoadingLayout v-if="!page || !message" :page="true" />

    <template v-if="message">
      <Page
        :title="`${(message.status === 'draft') ? $t('sms.editingMessage') : $t('sms.viewingMessage')} '${message ? message.name : '...'}'`"
        size="fullWidth"
      >

        <Layout v-if="message.type !== 'template'" class="SMS-progress" size="full">
          <LayoutSection>
            <Card>
              <CardSection>
                <ul>
                  <li :class="{ 'active': page === 'filters' }" @click="tryToGoToPage('filters')"><span class="bullet">1</span><span class="text">{{($t('Filters'))}}</span></li>
                  <li :class="{ 'active': page === 'details', 'disabled': message && message.creationStep < 2 }" @click="tryToGoToPage('details')"><span class="bullet">2</span><span class="text">{{$t('Details')}}</span></li>
                  <li :class="{ 'active': page === 'scheduling', 'disabled': message && message.creationStep < 3 }" @click="tryToGoToPage('scheduling')"><span class="bullet">3</span><span class="text">{{$t('Scheduling')}}</span></li>
                </ul>
              </CardSection>
            </Card>
          </LayoutSection>
        </Layout>

        <edit-filters v-if="page === 'filters' && message" :smsMessage="message" @update="updateFromFilters" @goToPage="goToPage" ref="pageFilters"></edit-filters>
        <edit-details v-if="page === 'details' && message" :smsMessage="message" @update="updateFromDetails" @goToPage="goToPage" ref="pageDetails"></edit-details>
        <edit-scheduling v-if="page === 'scheduling' && message" :smsMessage="message" @update="updateFromSchedule" @goToPage="goToPage" ref="pageScheduling"></edit-scheduling>

      </Page>
    </template>

  </div>
</template>

<script>

// import _ from 'lodash'
// import OsBrowser from '@/data/OsBrowser'
import EditFilters from './SmsEditFilters.vue'
import EditDetails from './SmsEditDetails.vue'
import EditScheduling from './SmsEditScheduling.vue'

export default {
  name: 'SmsEdit',
  data() {
    return {
      page: '',
      message: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.page = to.params.page
    next()
  },
  mounted() {
    // load current notification
    NProgress.start()
    this.api.getSmsMessage(this.$route.params.id)
      .then((data) => {
        this.message = data
        this.page = this.$route.params.page
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  methods: {
    goToPage(page) {
      if (this.message) {
        const creationStep = this.message.creationStep
        if (page === 'details' && creationStep < 2) return
        if (page === 'scheduling' && creationStep < 3) return
        this.$router.push(`/messaging/sms/edit/id/${this.message.smsId}/page/${page}/`)
        this.page = page
      }
    },
    tryToGoToPage(page) {
      let ref
      if (page === this.page) {
        return
      } else if (this.page === 'filters') {
        ref = this.$refs.pageFilters
      } else if (this.page === 'details') {
        ref = this.$refs.pageDetails
      } else if (this.page === 'scheduling') {
        ref = this.$refs.pageScheduling
      }
      if ((page === 'details' && this.message.creationStep < 2) || (page === 'scheduling' && this.message.creationStep < 3)) {
        return
      }
      if (ref) {
        // let forceSave = true
        // if (this.message.status === 'active') {
        //   forceSave = false
        // }
        ref.changePage(page, false)
      }
    },
    updateFromFilters(newDetails) {
      // no editing
      if (this.message.status !== 'draft') {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (!newDetails.siteId) {
        this.$ui.alert({ title: this.$t('sms.selectDomainMessage') })
        return
      }
      this.message.filters = JSON.parse(JSON.stringify(newDetails.filters))
      this.message.segments = this.message.segments || {}
      // this.notification.segments.browserLanguage = newDetails.language
      // this.notification.segments.tz = newDetails.timezone
      this.message.siteId = newDetails.siteId
      this.message.segments.startDate = newDetails.startDate
      this.message.segments.endDate = newDetails.endDate
      // this.message.isBroadcastMessage = newDetails.isBroadcastMessage
      if (this.message.creationStep < 2) {
        this.message.creationStep = 2
      }
      // update ...
      NProgress.start()
      this.api.updateSmsMessage(this.message)
        .then((response) => {
          this.message = response
          this.goToPage(newDetails.nextPage)
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    },
    updateFromDetails(newDetails) {
      // no editing
      if (this.message.status !== 'draft' && this.message.type !== 'template') {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (this.message.creationStep < 3) {
        this.message.creationStep = 3
      }
      this.message.definition = JSON.parse(JSON.stringify(newDetails.definition))
      //
      if (newDetails.nextPage === 'activateMessage') {
        this.message.status = 'active'
      }
      //
      NProgress.start()
      this.api.updateSmsMessage(this.message)
        .then((response) => {
          this.message = response
          this.$ui.toast({ title: this.$t('Saved') })
          if (newDetails.nextPage === 'saveTriggered') {
            this.$router.push('/messaging/sms/list/type/template/status/draft/')
          } else if (newDetails.nextPage === 'activateMessage') {
            this.$router.push('/messaging/sms/list/type/template/status/active/')
          } else {
            this.goToPage(newDetails.nextPage)
          }
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    },
    updateFromSchedule(newDetails) {
      this.message.scheduledDate = newDetails.date
      this.message.scheduledTime = newDetails.time

      if (this.message.status !== 'draft') {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (this.message.creationStep < 4) {
        this.message.creationStep = 4
      }
      if (newDetails.nextPage === 'send') {
        this.message.status = 'scheduled'
      }

      NProgress.start()
      this.api.updateSmsMessage(this.message)
        .then((response) => {
          this.message = response
          if (newDetails.nextPage === 'send') {
            this.$router.push('/messaging/sms/list/type/manual/status/scheduled/')
          } else if (newDetails.nextPage === 'save') {
            this.$router.push('/messaging/sms/list/type/manual/status/draft/')
          } else {
            this.goToPage(newDetails.nextPage)
          }
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    }
  },
  components: {
    EditFilters,
    EditDetails,
    EditScheduling
  }
};
</script>

<style lang="less">
  .SMS-progress {
    margin-bottom: 15px;

    ul {
      display: flex;
      list-style-type: none;
      padding: 0;
      margin-bottom: 0px;
      li {
        flex: 1;
        width: auto;
        display: flex;
        cursor: pointer;
        justify-content: center;
        margin-left: 5px;
        margin-right: 5px;
        padding: 10px;
        &.disabled {
          color: #ccc;
          cursor: auto;
          .bullet {
            background: #ccc;
          }
        }
        .bullet {
          display: inline-block;
          background: #aaa;
          color: #fff;
          width: 25px;
          height: 25px;
          padding-top: 4px;
          border-radius: 50%;
          text-align: center;
          flex: 0 0 25px;
        }
        .text {
          display: inline-block;
          margin-left: 15px;
          margin-top: 4px;
        }
        &.active {
          .bullet {
            background: #ff9800;
          }
          .text {
            color: #ff9800;
          }
        }
      }
    }
  }
  .loading {
    text-align: center;
    padding: 30px;
    padding-bottom: 150px;
  }
</style>
